<div class="container">
    <div class="row g-3">
        <div class="col-xl-8 col-lg-8 col-md-6 col-12">
            <div class="d-flex">
                <h2 class="m-0">
                    ตั้งค่าคูปอง
                </h2>
                <button class="btn btn-primary ms-md-2 ms-auto" (click)="addCoupon()">เพิ่มคูปอง</button>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-12 text-md-end">
            <!-- <div class="input-icon-start">
                <input type="text" class="form-control" placeholder="ค้นหาคูปอง">
                <span class="material-symbols-outlined">
                    search
                </span>
            </div> -->
            <app-filter [text]="'ค้นหาคูปอง'" (updateValue)="getCoupon($event)"></app-filter>
        </div>
    </div>
    <br>
    <div class="row g-3">
        <div class="col-12">
            <table class="table align-middle" *ngIf="couponItems">
                <thead>
                    <tr>
                        <th class="d-none d-md-table-cell">คูปอง</th>
                        <th class="d-none d-md-table-cell"></th>
                        <th class="d-none d-lg-table-cell">ประเภท</th>
                        <th class="d-none d-md-table-cell">วันที่หมดอายุ</th>
                        <th class="d-none d-md-table-cell">จำนวนคูปองคงเหลือ</th>
                        <th class="d-none d-md-table-cell"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let cp of couponItems">
                        <td [width]="48">
                            <img [src]="cp.Image" alt="">
                        </td>
                        <td><b>{{cp.Name}}</b>
                            <br>
                            <div class="detail d-block d-md-none">

                                <span>ประเภทคูปอง:
                                    <span *ngIf="cp.Type == 'discount'">ส่วนลด</span>
                                    <span *ngIf="cp.Type != 'discount'">สิ่งของ</span>
                                </span>
                                <br>
                                <span>คงเหลือ : {{cp.Amount}}</span>
                                <br>
                                <span>วันที่หมดอายุ:
                                    {{cp.Expire_start | date:'dd/MM/yyyy'}} -
                                    {{cp.Expire_end | date:'dd/MM/yyyy'}}</span>
                            </div>
                        </td>
                        <td class="d-none d-lg-table-cell d-xl-table-cell "><span class="content-text">
                                <span *ngIf="cp.Type == 'discount'">ส่วนลด</span>
                                <span *ngIf="cp.Type != 'discount'">สิ่งของ</span>
                            </span>
                        </td>
                        <td class="d-none d-lg-table-cell d-xl-table-cell d-md-table-cell">
                            <span>{{cp.Expire_start | date:'dd/MM/yyyy'}} -
                                {{cp.Expire_end | date:'dd/MM/yyyy'}}</span>
                        </td>
                        <td class="d-none d-lg-table-cell d-xl-table-cell d-md-table-cell">
                            {{cp.Amount}}
                        </td>
                        <td class="text-end">
                            <!-- <button class="btn btn-cancel me-2" (click)="deleteCoupon(cp)">
                                ลบ</button>
                            <button class="btn btn-primary " (click)="viewCoupon(cp)">แก้ไข</button> -->
                            <span class="material-icons pointer" (click)="viewMenu(cp,menu,$event)">
                                more_vert
                            </span>
                            <p-menu [model]="setitem" #menu [popup]="true"></p-menu>
                        </td>
                    </tr>
                </tbody>
            </table>
            <app-pagination *ngIf="couponItems" [page]="1" [pageTotal]="pageTotal"
                (updatePage)="getCoupon($event)"></app-pagination>
        </div>
    </div>

</div>




<p-dialog [header]="message" [(visible)]="manageReward" [modal]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '50vw' }" [formGroup]="formCoupon"
    (onHide)="clearEvent()">
    <ng-container *ngIf="manageReward">
        <br><br>
        <div class="row g-3">
            <div class="col-12 mb-3 image text-center">
                <app-upload-file [action]="imageAction" (FileUpload)="uploadFile($event)">
                    <div class="box-image pointer" *ngIf="!viewImage && !formCoupon.value['Image']">
                        <br><br>
                        <div class="icon-box">
                            <span class="material-symbols-outlined">
                                upload
                            </span>
                        </div>
                        <br>
                        อัพโหลดรูปภาพ
                        <br>
                        ขนาดไฟล์ไม่เกิน 1 MB
                    </div>
                    <img class="pointer" [src]="viewImage" width="100%" *ngIf="viewImage && addStatus">
                    <img class="pointer" [src]="viewImage" width="100%" *ngIf="viewImage  && updateStatus">
                    <img class="pointer" [src]="formCoupon.value['Image']" width="100%"
                        *ngIf="!viewImage && formCoupon.value['Image'] && updateStatus">
                </app-upload-file>
            </div>
            <div class="col-12">
                <p>ชือคูปอง <span class="text-danger">*</span></p>
                <input type="text" class="form-control" formControlName="Name"
                    placeholder="ตัวอย่างเช่น ส่วนลด 100 บาท">
            </div>
            <div class="col-12">
                <p>เงื่อนไขการใช้สิทธิ์</p>
                <textarea class="form-control termsuse" formControlName="Condition"
                    placeholder="อธิบายข้อกำหนดและเงื่อนไขการใช้คูปอง"></textarea>
                <!-- <input type="text" class="form-control" formControlName="Condition"> -->
            </div>
            <div class="col-12">
                <p>ประเภทคูปอง</p>
                <select class="form-select" formControlName="Type">
                    <option value="">เลือกประเภท</option>
                    <option value="discount">ส่วนลด</option>
                    <option value="things">สิ่งของ</option>
                </select>
            </div>
            <ng-container *ngIf="formCoupon.value['Type'] == 'discount'">
                <div class="col-12">
                    <p>ประเภทส่วนลด</p>
                    <select class="form-select" formControlName="DisType">
                        <option value="">เลือกประเภทส่วนลด</option>
                        <option value="amount">ส่วนลดแบบระบุจำนวน</option>
                        <option value="percentage">ส่วนลดแบบ %</option>
                    </select>
                </div>
                <div class="col-12">
                    <p>ส่วนลด</p>
                    <input type="number" class="form-control" formControlName="DisAmount">
                </div>
            </ng-container>
            <div class="col-12">
                <p>จำนวนคงเหลือ</p>
                <input type="number" class="form-control" formControlName="Amount" placeholder="0">
            </div>
        </div>
        <br>
        <div class="row g-3">
            <!-- <div class="col-12">
                <app-checkbox [InputValue]="formCoupon.value['Expire'] || 0"
                    (updateValue)="expire($event)">วันที่หมดอายุ</app-checkbox>
            </div> -->
            <ng-container *ngIf="formCoupon.value['Expire'] == 1">
                <div class="col-6">
                    <p>วันที่เริ่ม</p>
                    <div class="calendar-icon-start">
                        <p-calendar styleClass="w-100" formControlName="Expire_start_edit" dateFormat="dd/mm/yy"
                            (onSelect)="updateExpire($event,'start')" [touchUI]="true"></p-calendar>
                        <span class="material-symbols-outlined icon">
                            calendar_today
                        </span>
                    </div>
                </div>
                <div class="col-6">
                    <p>วันที่สิ้นสุด</p>
                    <div class="calendar-icon-start">
                        <p-calendar styleClass="w-100" formControlName="Expire_end_edit" dateFormat="dd/mm/yy"
                            (onSelect)="updateExpire($event,'end')" [touchUI]="true">
                        </p-calendar>
                        <span class="material-symbols-outlined icon">
                            calendar_today
                        </span>
                    </div>
                </div>
            </ng-container>

        </div>
        <div class="row">
            <div class="col-12 text-end mt-3">
                <button class="btn btn-cancel me-3" (click)="clearEvent()">
                    ยกเลิก
                </button>
                <button class="btn btn-primary" *ngIf="addStatus" (click)="createCoupon()">
                    บันทึก
                </button>
                <button class="btn btn-primary " *ngIf="updateStatus" (click)="updateCoupon()">
                    บันทึก
                </button>
            </div>
        </div>
    </ng-container>
</p-dialog>